var render, staticRenderFns
import script from "./DifferentFormTable.vue?vue&type=script&lang=js"
export * from "./DifferentFormTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616d4a85')) {
      api.createRecord('616d4a85', component.options)
    } else {
      api.reload('616d4a85', component.options)
    }
    
  }
}
component.options.__file = "src/views/dms/views/new-column/column-s/form/DifferentFormTable.vue"
export default component.exports